document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('ContactForm');

    if (!form) {
      console.error('Form with ID "ContactForm" not found.');
      return;
    }

    const inputs = form.querySelectorAll('.field__input:not(#ContactForm-body)');
    const submitButton = form.querySelector('.contact__button button');
    let formInteracted = false;
  
    function validateField(input) {
      const errorElement = input.closest('.field-wrapper').querySelector('.field__error');
      const fieldWrapper = input.closest('.field-wrapper');
      
      if (input.value.trim() === '') {
        fieldWrapper.classList.add('field--error');
        errorElement.style.display = 'block';
        return false;
      } else {
        fieldWrapper.classList.remove('field--error');
        errorElement.style.display = 'none';
        return true;
      }
    }
  
    function checkFormValidity() {
      let allValid = true;
      inputs.forEach(function(input) {
        if (input.value.trim() === '') {
          allValid = false;
        }
      });
  
      if (allValid) {
        submitButton.classList.remove('button--disabled');
        submitButton.removeAttribute('disabled');
        submitButton.style.cursor = 'pointer';
      } else {
        submitButton.classList.add('button--disabled');
        submitButton.setAttribute('disabled', 'true');
        submitButton.style.cursor = 'not-allowed';
      }
    }
  
    inputs.forEach(function(input) {
      input.addEventListener('blur', function() {
        formInteracted = true; 
        validateField(input); 
        checkFormValidity(); 
      });
    });
  
    form.addEventListener('submit', function(event) {
      let hasErrors = false;
      
      inputs.forEach(function(input) {
        if (!validateField(input)) {
          hasErrors = true;
        }
      });
  
      if (hasErrors) {
        event.preventDefault();
      }
    });
  
    checkFormValidity();
  });
  